// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { FeatureSetting } from './feature-setting';
import { Product } from './product';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Feature extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  createdAt!: Date;
  createdBy?: string;
  featureDescription?: string;
  featureName?: string;
  featureType!: string;
  hasRole!: boolean;
  productId!: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  featureSettings!: FeatureSetting[];
  product!: Product;
}

